import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';

export interface MultiSelectDropdownItem {
  id: string;
  label: string;
}

@Component({
  selector: 'multi-select-dropdown',
  templateUrl: './multi-select-dropdown.component.html',
  styleUrls: ['./multi-select-dropdown.component.scss'],
  standalone: false,
})
export class MultiSelectDropdownComponent {
  @Input() items: MultiSelectDropdownItem[] = [];
  @Input() selectedIds: readonly string[] = [];
  @Input() open = false;
  @Input() triggerText = 'Add Calendar';
  /** Element id for the trigger button (e2e, aria-labelledby). */
  @Input() triggerId = '';
  /** Space-separated element ids for aria-labelledby. */
  @Input() ariaLabelledBy = '';
  @Output() openChange = new EventEmitter<boolean>();
  @Output() selectionToggle = new EventEmitter<string>();

  constructor(private elementRef: ElementRef<HTMLElement>) {}

  @HostListener('document:click', ['$event'])
  onDocumentClick(ev: MouseEvent): void {
    if (!this.open) {
      return;
    }
    const target = ev.target as Node;
    if (!this.elementRef.nativeElement.contains(target)) {
      this.openChange.emit(false);
    }
  }

  onTriggerClick(ev: Event): void {
    ev.stopPropagation();
    this.openChange.emit(!this.open);
  }

  isSelected(id: string): boolean {
    return this.selectedIds.includes(id);
  }

  onToggleItem(id: string): void {
    this.selectionToggle.emit(id);
  }
}
